import React from 'react';
import { FaGoogle, FaFacebookF, FaApple } from 'react-icons/fa';
import signup from '../assets/signup.jpg';
import logo from '../assets/logo.svg';

const Signup = () => {
  return (
    <div className="min-h-screen flex items-center justify-center relative" style={{ backgroundImage: `url(${signup})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      {/* Left Side */}
      <div className="hidden md:flex flex-col justify-center items-start text-white p-16 w-1/2 space-y-4">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Logo" className="w-50 h-50" />
          
        </div>
      </div>

      {/* Right Side */}
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md md:ml-10 md:mr-16">
        <h1 className="text-3xl font-bold mb-6">Create an account</h1>
        <div className="flex space-x-4 mb-6">
          <button className="flex items-center justify-center w-10 h-10 rounded-full border border-gray-300">
            <FaApple className="text-black" />
          </button>
          <button className="flex items-center justify-center w-10 h-10 rounded-full border border-gray-300">
            <FaGoogle className="text-red-500" />
          </button>
          <button className="flex items-center justify-center w-10 h-10 rounded-full border border-gray-300">
            <FaFacebookF className="text-blue-500" />
          </button>
        </div>
        <div className="flex items-center justify-between mb-4">
          <hr className="w-full border-gray-300" />
          <span className="px-2 text-gray-400">Or</span>
          <hr className="w-full border-gray-300" />
        </div>
        <form className="space-y-4">
        <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700">
              Username
            </label>
            <input
              type="username"
              id="username"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Username"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <input
              type="email"
              id="email"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Email address"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Password"
            />
          </div>
          <div>
            <label htmlFor="confirmpassword" className="block text-sm font-medium text-gray-700">
             Confirm Password
            </label>
            <input
              type="confirmpassword"
              id="confirmpassword"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Confirm Password"
            />
          </div>
          <div>
            <button
              type="submit"
              className="w-full py-2 px-4 bg-blue-600 text-white rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
             Singup
            </button>
          </div>
        </form>
        <p className="mt-6 text-sm text-gray-500">
          Already have an account? <a href="/login" className="text-blue-600 hover:underline">Sign in</a>
        </p>
      </div>
    </div>
  );
};

export default Signup;
